/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "89b7049cc16e7d4a8ae41683c3a66ec19a4062a8";
